import React from 'react';
import {
    Cell,
    Grid,
    H2,
} from '@saladbob/sassafras'

import Game from './Game';
import ByGame from './ByGame';

import style from './bracket.module.css';

import { Game as GameType } from '../../types'

type Props = {
    games: GameType[],
    tbGames: GameType[],
};

const Bracket11: React.FC<Props> = ({games, tbGames}) => {
    return (
        <div style={{ height: '100%' }}>
            <Grid columns="repeat(7, 1fr)">
                {/* Round 1 */}
                <Grid rows="repeat(40, 1fr)">
                    <Cell style={{ gridRow: '2 / 4' }}>
                        <Game game={games[0]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '6 / 8' }}>
                        <Game game={games[1]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '10 / 12' }}>
                        <Game game={games[2]} topLabel bottomLabel />
                    </Cell>

                    {/* Losers */}

                    <Cell style={{ gridRow: '22 / 23' }} ps="md">
                        <H2 font="leader" className={style.bracketHeading} color="primary">LOSERS BRACKET</H2>
                    </Cell>

                    <Cell style={{ gridRow: '24 / 26' }}>
                        <Game game={games[7]} topLabel bottomLabel/>
                    </Cell>
                    <Cell style={{ gridRow: '28 / 30' }}>
                        <Game game={games[8]} topLabel bottomLabel/>
                    </Cell>
                    <Cell style={{ gridRow: '33 / 35' }}>
                        <Game game={games[9]} topLabel bottomLabel/>
                    </Cell>
                </Grid>
                {/* Round 2 */}
                <Grid columns="1fr" rows="repeat(40, 1fr)">
                    <Cell style={{ gridRow: '1 / 3' }}>
                        <Game game={games[3]} topLabel />
                    </Cell>
                    <Cell style={{ gridRow: '5 / 7' }}>
                        <Game game={games[4]} topLabel  />
                    </Cell>
                    <Cell style={{ gridRow: '9 / 11' }}>
                        <Game game={games[5]} topLabel  />
                    </Cell>
                    <Cell style={{ gridRow: '13 / 15' }}>
                        <Game game={games[6]} topLabel bottomLabel />
                    </Cell>

                    {/* Toilet Bowl Heading */}

                    <Cell style={{ gridRow: '17 / 23' }} align="center" justify="flex-end" pe="md">
                        <H2 font="leader" className={style.bracketHeading} color="primary">TOILET BOWL BRACKET</H2>
                    </Cell>

                    {/* Losers */}

                    <Cell style={{ gridRow: '25 / 29' }}>
                        <Game game={games[12]} />
                    </Cell>
                    <Cell style={{ gridRow: '34 / 36' }}>
                        <Game game={games[13]} bottomLabel />
                    </Cell>
                </Grid>
                {/* Round 3 */}
                <Grid columns="1fr" rows="repeat(40, 1fr)">
                    <Cell style={{ gridRow: '2 / 6' }}>
                        <Game game={games[10]} />
                    </Cell>
                    <Cell style={{ gridRow: '10 / 14' }}>
                        <Game game={games[11]} />
                    </Cell>

                    {/* Toilet Bowl */}

                    <Cell style={{ gridRow: '17 / 19' }} bgColor="tertiary200">
                        <Game game={tbGames[0]} bottomLabel topLabel />
                    </Cell>
                    <Cell style={{ gridRow: '19 / 21' }} bgColor="tertiary200" />
                    <Cell style={{ gridRow: '21 / 23' }} bgColor="tertiary200">
                        <Game game={tbGames[1]} bottomLabel topLabel />
                    </Cell>

                    {/* Losers */}

                    <Cell style={{ gridRow: '27 / 30' }}>
                        <Game game={games[14]} bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '35 / 37' }}>
                        <Game game={games[15]} bottomLabel/>
                    </Cell>
                </Grid>
                {/* Round 4 */}
                <Grid columns="1fr" rows="repeat(40, 1fr)">
                    <Cell style={{ gridRow: '4 / 12' }}>
                        <Game game={games[16]} />
                    </Cell>

                    {/* Toilet Bowl */}
                    <Cell style={{ gridRow: '17 / 18' }} bgColor="tertiary200" />

                    <Cell style={{ gridRow: '18 / 22' }} bgColor="tertiary200" >
                        <Game game={tbGames[2]} />
                    </Cell>

                    <Cell style={{ gridRow: '22 / 23' }} bgColor="tertiary200" />

                    {/* Losers */}

                    <Cell style={{ gridRow: '29 / 36' }}>
                        <Game game={games[17]} />
                    </Cell>
                </Grid>

                {/* Round 5 */}
                <Grid columns="1fr" rows="repeat(40, 1fr)">
                    <Cell style={{ gridRow: '8 / 10' }}>
                        <ByGame />
                    </Cell>

                    {/* TB Winner */}

                    <Cell style={{ gridRow: '17 / 20' }} bgColor="tertiary200" width="100px" />

                    <Cell style={{ gridRow: '20 / 22' }} bgColor="tertiary200" width="100px">
                        <ByGame tb color="black" />
                    </Cell>

                    <Cell style={{ gridRow: '22 / 23' }} bgColor="tertiary200" width="100px" />

                    {/* Losers */}

                    <Cell style={{ gridRow: '33 / 37' }}>
                        <Game game={games[18]}
                            bottomLabel
                            trophy='trophy'
                            trophyColor={['#A05822', 'white']}
                        />
                    </Cell>
                </Grid>
                {/* Round 6 */}
                <Grid columns="1fr" rows="repeat(40, 1fr)">
                    <Cell style={{ gridRow: '8 / 35' }}>
                        <Game game={games[19]} />
                    </Cell>
                </Grid>
                {/* Round 7 */}
                <Grid columns="1fr" rows="repeat(40, 1fr)" className={`${style.championship} ${style.printOnly}`}>
                    <Cell style={{ gridRow: '20 / 22' }} width="100px">
                        <ByGame trophy loserTrophy />
                    </Cell>

                    <Cell style={{ gridRow: '23 / 25' }}>
                        <Game game={games[20]} />
                    </Cell>
                </Grid>

                {games[19].winner && games[19].team2.id === games[19].winner.id && (
                    <Grid columns="1fr" rows="repeat(40, 1fr)" className={`${style.championship} ${style.screenOnly}`}>
                        <Cell style={{ gridRow: '16 / 27' }} width="260px">
                            <Game game={games[20]} />
                        </Cell>
                    </Grid>
                )}
                <Grid columns="1fr" rows="repeat(40, 1fr)" className={`${style.championship} ${style.screenOnly}`}>
                    <Cell style={{ gridRow: '20 / 22' }} width="100px">
                        <ByGame trophy loserTrophy />
                    </Cell>
                </Grid>
            </Grid>
        </div>
    );
}

export default Bracket11;
